<template>
    <div ref="stickyWrapper" class="stickyScrollContainer">
        <slot></slot>
    </div>
</template>

<style src="./StaticTableFormater.scss"></style>
<script lang="ts" src="./StaticTableFormater"></script>
